import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
} from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { DEMO_FEATURE_UNAVAILABLE, isDemoLocked } from "../utils/demoConfig";

const EmployeeAccountsTableDropdown = ({
  data,
  setUpdateTitle,
  setUpdateBody,
  setUpdateData,
  setUpdateBtnText,
  setUpdateBtnColor,
  setToggleModal,
  setDataModal,
  setLastAction,
  editDisabled,
}) => {
  const currentRoute = useLocation().pathname;
  const [dropdownOpen, setOpen] = useState(false);
  const toggle = () => setOpen(!dropdownOpen);
  
  const editLink = `${currentRoute}/${data.id}/update/`;

  const activateBtnText = data.is_active ? "Deactivate" : "Activate";
  const activateBtnColor = data.is_active? "danger" : "success";
  const activateAction = data.is_active ? `Account de-activated for Employee Account ${data.username}.` : `Account activated for Employee Account ${data.username}.`;
  const activateUpdateData = data.is_active? {"is_active": false} : {"is_active": true};
  const activateBodyText = data.is_active? `Are you sure you want to De-Activate Employee Account ${data.username}` : `Are you sure you want to Activate Employee Account ${data.username}?`;

  const actionsDisabled = editDisabled || isDemoLocked();
  const actionTooltipId = `employee-actions-${data.id}`;

  return (
    <>
      <ButtonDropdown isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle
          id={actionTooltipId}
          caret
          outline
          color="primary"
          disabled={actionsDisabled}
        >
          Action
        </DropdownToggle>

        <DropdownMenu>
          <DropdownItem disabled={actionsDisabled}>
            {actionsDisabled ? <>Edit</> : <Link to={editLink}>Edit</Link>}
          </DropdownItem>
          <DropdownItem
            disabled={actionsDisabled}
            onClick={() => {
              if (actionsDisabled) return;
              setUpdateBtnText(activateBtnText);
              setUpdateBtnColor(activateBtnColor);
              setUpdateData(activateUpdateData);
              setUpdateBody(activateBodyText);
              setLastAction(activateAction);
              setDataModal(data);
              setToggleModal(true);
            }}
            style={{ cursor: actionsDisabled ? "default" : "pointer" }}
          >
            {activateBtnText}
          </DropdownItem>
        </DropdownMenu>
      </ButtonDropdown>
      {actionsDisabled && (
        <UncontrolledTooltip placement="bottom" target={actionTooltipId}>
          {DEMO_FEATURE_UNAVAILABLE}
        </UncontrolledTooltip>
      )}
    </>
  );
};

export default EmployeeAccountsTableDropdown;
